import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { ModalMisReservasPage } from './modal-mis-reservas.page';

const routes: Routes = [
  {
    path: '',
    component: ModalMisReservasPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [ModalMisReservasPage]
})
export class ModalMisReservasPageModule {}
